"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoostPricingTileComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("../../../types");
var _utils = require("../../../utils");
var _tailwindMerge = require("tailwind-merge");
var _TierPricing = require("./TierPricing");
var _TierFeatures = require("./TierFeatures");
var _JoinPrimary = require("./JoinPrimary");
var _JoinSecondary = require("./JoinSecondary");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BoostPricingTileComponent = exports.BoostPricingTileComponent = function BoostPricingTileComponent(props) {
  var isMobile = props.isMobile,
    isHighlighted = props.isHighlighted,
    tileTheme = props.tileTheme,
    tier = props.tier,
    term = props.term,
    features = props.features,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    styleOverrides = props.styleOverrides,
    _props$isSecondaryJoi = props.isSecondaryJoinVisible,
    isSecondaryJoinVisible = _props$isSecondaryJoi === void 0 ? false : _props$isSecondaryJoi,
    _props$isPrimaryJoinV = props.isPrimaryJoinVisible,
    isPrimaryJoinVisible = _props$isPrimaryJoinV === void 0 ? true : _props$isPrimaryJoinV,
    promotionPercentOff = props.promotionPercentOff,
    promotionCredit = props.promotionCredit,
    _props$isLanding = props.isLanding,
    isLanding = _props$isLanding === void 0 ? false : _props$isLanding;
  var secondaryTerm = term === _types.BoostTerm.MONTHLY ? _types.BoostTerm.YEARLY : _types.BoostTerm.MONTHLY;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: isLanding ? (0, _tailwindMerge.twMerge)("flex flex-col rounded-t-3xl rounded-b-3xl ".concat(isMobile ? "max-w-[342px] h-max" : "max-w-[388px] h-auto h-[844px]", " \n          \"rounded-lg\" \n          ").concat(isHighlighted ? "bg-white border-0 [box-shadow:-7px_-7px_15px_#b9f,_-7px_7px_15px_#b9f,_7px_7px_15px_#b9f,_7px_-7px_30px_#b9f]" : "bg-neutral-700", " ").concat(className)) : (0, _tailwindMerge.twMerge)("flex flex-col p-6 mdl:p-6 xxl:p-10 ".concat(isMobile ? "max-w-[342px] h-max" : "max-w-[388px] h-auto h-[844px]", " \n        \"rounded-lg\" ").concat(isHighlighted ? "border-4 border-boost-primary-500 bg-boost-primary-200" : tileTheme === "light" ? "bg-white border-2 border-neutral-400" : "bg-neutral-700", " ").concat(className)),
    style: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.container
  }, /*#__PURE__*/_react["default"].createElement(_TierPricing.TierPricing, {
    tier: tier,
    term: term,
    theme: tileTheme,
    isMobile: isMobile,
    variant: props.hidePricing ? undefined : props.pricingVariant,
    hidePricing: props.hidePricing,
    promotionPercentOff: promotionPercentOff,
    promotionCredit: promotionCredit,
    isLanding: isLanding
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 ".concat(isLanding ? "px-6" : "")
  }, /*#__PURE__*/_react["default"].createElement(_TierFeatures.TierFeatures, {
    features: features,
    theme: tileTheme,
    isMobile: isMobile
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "m-6"
  }, isPrimaryJoinVisible && "buttonText" in props && /*#__PURE__*/_react["default"].createElement(_JoinPrimary.JoinPrimary, {
    title: props.buttonText,
    onClick: function onClick() {
      return props.onJoin(tier, term);
    },
    isHighlighted: Boolean(isHighlighted),
    theme: tileTheme,
    style: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.primaryButton
  }), isSecondaryJoinVisible && "onJoin" in props && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/_react["default"].createElement(_JoinSecondary.JoinSecondary, {
    isMobile: isMobile,
    theme: tileTheme,
    onClick: function onClick() {
      return props.onJoin(tier, secondaryTerm);
    },
    price: (0, _utils.calculatePerMonthPrice)(secondaryTerm, props.secondaryConfig.price, props.secondaryConfig.originalPrice).perMonthPrice,
    term: secondaryTerm
  }))));
};